let $middleBrown = '#5a3823'
let $selectTriggerBtn = {
  'border' : `1px solid ${$middleBrown}`,
  'color' : $middleBrown,
  'padding' : '0 10px'
}

  export default {
'button' : { 

 typeTheme :{ 
 'swtichAccount' : { 
  'line-height' : '30px',
  'width' : '160px'
 
}} 
}
,
'selectTriggerBtn' : { 

 typeTheme :{ 
 'bankSelect' : { 
  ...$selectTriggerBtn,
  'line-height' : '40px',
  'background-color' : 'white',
  'width' : '85%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center'
 
}} 
}

}